import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";

var _hoisted_1 = /*#__PURE__*/_createElementVNode("i", {
  "class": "fa fa-share"
}, null, -1);

var _hoisted_2 = {
  key: 0,
  "class": "nav-link-text ml-1"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("a", {
    "class": _normalizeClass(["nav-link", [{
      'text-blue': $data.isReSteem
    }]]),
    href: "javascript:void(0)",
    title: "resteem",
    onClick: _cache[0] || (_cache[0] = function () {
      return $options.resteem && $options.resteem.apply($options, arguments);
    })
  }, [_hoisted_1, $props.isShowText ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.$t("button.resteem")), 1)) : _createCommentVNode("", true)], 2);
}